import { render } from "./TransitDetail.vue?vue&type=template&id=6a6e55cf"
import script from "./TransitDetail.ts?vue&type=script&lang=ts"
export * from "./TransitDetail.ts?vue&type=script&lang=ts"

import "./TransitDetail.vue?vue&type=style&index=0&id=6a6e55cf&lang=css"
script.render = render

export default script